<template>
  <div>
    <div class="yk-wrap-fixed wlx-site-manager-wrapper">
      <header class="u-school-manager-head site-manager-head-con">
        <span class="fl sp-test-detail-title">{{meetTitle}}</span>
        <!-- <div style="float:right;"> -->
          <el-form :inline="true">
            <el-form-item>
              <div style="width:48%;float:left;margin-right:15px;">
                <el-input v-model="CreateDisplayName" placeholder="请输入申请人" clearable></el-input>
              </div>
              <div style="width:48%;float:left">
                <el-input v-model="companyName" placeholder="请输入单位" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              <a class="export-button-a" style="color:#fff" :href="exportExcel">按申请单位导出</a>
              <a class="export-button-a" style="color:#fff" :href="exportExcelStu">按报名人员导出</a>
              <el-button type="primary" icon="wl-icon-ai207" @click="goBack"></el-button>
            </el-form-item>
          </el-form>
        <!-- </div> -->
      </header>
 		<!-- <el-table-column prop="personCount"
                          label="报名人数"
                          show-overflow-tooltip>
          </el-table-column> -->
      <div class="wlx-table-content">
        <el-table
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="CreateDisplayName" show-overflow-tooltip label="申请人" width="200"></el-table-column>
          <el-table-column prop="CreateUserName" show-overflow-tooltip label="手机号" width="200"></el-table-column>
          <el-table-column prop="companyName" label="单位" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="zipCode" label="邮编" show-overflow-tooltip></el-table-column>
          <el-table-column prop="invoice" label="发票抬头" show-overflow-tooltip></el-table-column>
          <el-table-column prop="taxNumber" label="纳税人识别号" show-overflow-tooltip></el-table-column> -->
          <el-table-column prop="personCount" label="报名人数" show-overflow-tooltip width="160"></el-table-column>
          <el-table-column prop="dateCreated" label="创建时间" width="160"></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="el-icon-view"
                @click="goView(scope.row.id)"
                type="primary"
                title="详情"
              ></el-button>
              <!-- <el-button size="mini"
                        type="danger"
                        class="el-icon-delete"
                        @click="deleteMajor(scope.row.id)"
              titlt="删除"></el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="wl-pagination-text"
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      ids: [],
      CreateDisplayName: "",
      companyName:"",
      meetTitle: "",
      exportExcel:"",
      exportExcelStu:""
    };
  },
  props: {
    activityId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.school = this.$store.state.auth.userName;
    this.getMeetingEnrollList();
    this.exportExcel = "/api/XOrg/SpecialActivity/exportExcel?activityId="+ this.activityId;
    this.exportExcelStu =  "/api/XOrg/SpecialActivity/exportExcelStu?activityId="+ this.activityId;
  },
  methods: {
    getMeetingEnrollList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/SpecialActivity/getMeetingEnrollList", {
          createDisplayName: this.CreateDisplayName,
          companyName: this.companyName,
          activityId: this.activityId,
          page: page,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.meetTitle = rst.meetTitle;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    onPageChangeHandler(page) {
      this.getMeetingEnrollList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMeetingEnrollList(1);
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    },
    deleteMajor(id) {
      this.$confirm("此操作将删除该会议, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var that = this;
          this.$http
            .post("/api/XOrg/SpecialActivity/deleteSpecial", {
              id: that.id
            })
            .then(rst => {
              if (rst.code === 1) {
                that.$message({
                  message: rst.msg,
                  type: "success"
                });
                that.getMeetingEnrollList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getMeetingEnrollList(1);
    },
    goView(id) {
      this.$router.push({
        name: "checkSignUp",
        params: {
          signUpId: id,
          activityId: this.activityId
        }
      });
    },
    goBack() {
      this.$router.push({
        name: "MeetingManager"
      });
    }
  }
};
</script>

<style lang="scss">
.yk-wrap-fixed {
  .site-manager-head-con {
    text-align: right;
    height: 80px;
    line-height:80px;
}
  .el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
    padding-top: 18px;

}
  .sp-test-detail-title {
    padding: 0 15px;
    font-size: 16px;
    color: #2d82ff;
    // border-bottom: 2px solid #2d82ff;
    line-height: 80px;
    min-width: 30px;
    text-align: center;
  }
  .wlx-table-content {
    margin-top: 135px;
  }
  .el-table{
    margin-left:0;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    height: 34px;
  }
  .wl-pagination-text {
    text-align: center;
    margin-top: 30px;
  }
  .site-manager-head-con {
    text-align: right;
  }
  .el-form-item__content {
    .el-button {
      padding: 8px 15px;
    }
  }
  .export-button-a{
    color: #fff;
    background: #409EFF;
    padding: 8px 15px;
    border-radius: 4px;
    margin: 0 10px;
  }
}
</style>
